import { mapDTO } from '@twistezo/ts-dto-mapper'
import { UpdateAdUnitsMutationVariables } from 'gql/graphql'

import { AdUnitTableSchema } from 'features/inventory/ad-unit/forms/AdUnitTableForm/schema'

type From = AdUnitTableSchema
type To = UpdateAdUnitsMutationVariables['input']

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ adUnitsAttributes }: From): To => ({
      adUnitsAttributes: Object.entries(adUnitsAttributes).map(([id, attributes]) => ({
        id,
        ...attributes,
      })),
    }),
  )
